import { OptionRowValue } from 'elements/minute/sidebar/sidebarComponents/atomic/OptionRowValue';
import { SliderValue } from 'elements/minute/sidebar/sidebarComponents/atomic/SliderValue';
import { ColorPalette } from 'elements/minute/sidebar/sidebarComponents/complex/ColorPalette';
import { SidebarContent } from 'elements/minute/sidebar/sidebarSection/SidebarContent';
import { SidebarSection } from 'elements/minute/sidebar/sidebarSection/SidebarSection';
import { SidebarSubsection } from 'elements/minute/sidebar/sidebarSection/SidebarSubsection';
import { useMapheimDebounced } from 'hooks/general/useMapheimDebounced';
import { IMarkerDefault } from 'libs/utils/marker/markerTypes';
import { useContext, useState } from 'react';
import { CtxEdit } from 'session/ctxEdit';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';
import { useUpdateEffect } from 'usehooks-ts';

interface Props {
    className?: string;
}

const DRAW_SIZES = [2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30];

export const DrawToolStyleSection = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);

    const [markerDefault, setMarkerDefault] = useState(ctxEdit.markerDefault);

    function updateLocalState(params: Partial<IMarkerDefault>) {
        setMarkerDefault((curr) => ({ ...curr, ...params }));
    }
    const updateLocalStateDebounced = useMapheimDebounced(updateLocalState, 100);

    useUpdateEffect(() => {
        ctxEdit.setMarkerDefault(markerDefault);
    }, [markerDefault]);

    return (
        <S_LineMarkerStyleSection className={props.className}>
            <SidebarSection title={Localization.STYLE} icon={{ iconName: 'brush' }}>
                <SidebarSubsection title="Color" icon={{ iconName: 'circle' }}>
                    <SidebarContent>
                        <ColorPalette
                            value={markerDefault.color}
                            pickerAllowed
                            onChange={(color) => {
                                updateLocalState({ color });
                            }}
                        />
                    </SidebarContent>
                </SidebarSubsection>
                <SidebarSubsection title="Type" icon={{ iconName: 'scribble' }}>
                    <SidebarContent>
                        <OptionRowValue
                            items={[{ iconName: 'pen-line' }, { iconName: 'highlighter-line' }]}
                            selectedIndex={markerDefault.drawType === 'brush' ? 1 : 0}
                            onSelected={(option) => {
                                updateLocalState({ drawType: option ? 'brush' : 'pen' });
                            }}
                        />
                    </SidebarContent>
                </SidebarSubsection>
                <SidebarSubsection title="Fill" icon={{ iconName: 'ruler' }}>
                    <SidebarContent>
                        <OptionRowValue
                            items={[{ iconName: 'circle' }, { iconName: 'circle', iconSet: 'fas' }]}
                            selectedIndex={markerDefault.drawFill ? 1 : 0}
                            onSelected={(option) => {
                                updateLocalState({ drawFill: option === 1 ? true : false });
                            }}
                        />
                    </SidebarContent>
                </SidebarSubsection>
                <SidebarSubsection title="Size" icon={{ iconName: 'ruler' }}>
                    <SidebarContent>
                        <SliderValue
                            steps={DRAW_SIZES}
                            value={markerDefault.drawSize}
                            onValueChange={(value) => {
                                updateLocalStateDebounced({ drawSize: value });
                            }}
                        />
                    </SidebarContent>
                </SidebarSubsection>
            </SidebarSection>
        </S_LineMarkerStyleSection>
    );
};

const S_LineMarkerStyleSection = styled.div``;
